export const DRIFT_SESSION_ID = 'SESSION_ID'
export const DRIFT_SESSION_STARTED = 'SESSION_STARTED'
export const ALWAYS_SEND_IDS_SESSION_STORE_KEY = 'ALWAYS_SEND_IDS'
export const DRIFT_SESSION_CAMPAIGNS = 'SESSION_CAMPAIGNS'

export const SessionStorageItems = [
  DRIFT_SESSION_ID,
  DRIFT_SESSION_STARTED,
  ALWAYS_SEND_IDS_SESSION_STORE_KEY,
  DRIFT_SESSION_CAMPAIGNS
]

